// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.movementsContainer {
    width: 100%;
    height: 100%;
    margin: auto;
    overflow: auto;
}

ol.stageMovementsStages h4 {
    text-align: center;
    text-wrap: nowrap;
    overflow: hidden;
    max-width: 300px;
    text-overflow: ellipsis;
}

ol.stageMovementsStages,
ol.stageMovementsStages ol,
ol.stageMovementsStages li,
ol.stageMovementsStages li > div {
    position: relative;
    margin-right: 6px;
}

.stageMovementsStages {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
}

.arrowStage {
    width: 300px;
    height: 50px;
    position: relative;
    cursor: pointer;
}

.arrowStage:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 12px solid white;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
}

.arrowStage:before {
    content: "";
    position: absolute;
    right: -12px;
    bottom: 0;
    width: 0;
    height: 0;
    border-left: 12px solid;
    border-top: 25px solid transparent;
    border-bottom: 25px solid transparent;
}

.arrowStageText {
    position: absolute;
    margin-top: 12px;
    margin-left: 140px;
    color: white;
    font-family: SANS-SERIF;
    font-size: 15px;
    text-align: center;
}

ol.stageMovementsStates,
ol.stageMovementsStates ol,
ol.stageMovementsStates li {
    list-style: none;
    margin: 0;
    padding: 0;
}

ol.stageMovementsStates li > div {
    width: 220px;
    min-height: 80px;
    margin-top: 30px;
    margin-left: 50px;
    padding: 10px;
    background-color: #ececec;
    border: 1px solid #d6d4d4;
}

ol.stageMovementsStates span { display: block; }

.boldSpanName { font-weight: bold; }

.spanLength {
    float: right;
    color: #2a9c1a;
}


ol.stageMovementsStages ol:before,
ol.stageMovementsStages ol:after,
ol.stageMovementsStages li:before,
ol.stageMovementsStages li:after,
ol.stageMovementsStages > li > div:before,
ol.stageMovementsStages > li > div:after {
    background-color: #d6d4d4;
    content: '';
    position: absolute;
}

ol.stageMovementsStages ol > li { padding: 1em 0 0 1em; }

ol.stageMovementsStages > li > ol > li:not(:last-of-type):before {
    height: 3px;
    left: 30px;
    top: 6em;
    width: 3em;
}

ol.stageMovementsStages > li > ol > li:not(:last-of-type):after {
    height: 100%;
    left: 30px;
    top: 0;
    width: 3px;
}

ol.stageMovementsStages > li > ol > li:last-of-type:before {
    height: 3px;
    left: 30px;
    top: 6em;
    width: 3em;
}

ol.stageMovementsStages > li > ol > li:last-of-type:after {
    height: 6em;
    left: 30px;
    top: 0;
    width: 3px;
}


ol.processMovements,
ol.processMovements ol,
ol.processMovements li,
ol.processMovements li > div {
    position: relative;
    margin-left: 6px;
    list-style: none;
}

.processMovements {
    margin: 0;
    padding: 0;
}

ol.processItemMovements,
ol.processItemMovements ol,
ol.processItemMovements li {
    margin: 0;
    padding: 0;
}

ol.processItemMovements,
ol.processItemMovements ol,
ol.processItemMovements li,
ol.processMovements span {
    display: block;
}

ol.processItemMovements li > div {
    width: 220px;
    min-height: 70px;
    margin-top: 15px;
    margin-left: 45px;
    padding: 10px;
    background-color: #ececec;
    border: 1px solid #d6d4d4;
}

ol.processItemMovements span { display: block; }

.processStateMovements {
    display: flex;
    left: 150px;
    margin-top: -75px;
    margin-bottom: 50px;
}

.processNameSpan {
    margin-top: 35px;
    margin-bottom: 5px;
}

ol.processStateMovements h4 {
    text-align: center;
    text-wrap: nowrap;
    overflow: hidden;
    max-width: 300px;
    text-overflow: ellipsis;
}

ol.processStateMovements ol:before,
ol.processStateMovements ol:after,
ol.processStateMovements li:before,
ol.processStateMovements li:after,
ol.processStateMovements > li > div:before,
ol.processStateMovements > li > div:after {
    background-color: #d6d4d4;
    content: '';
    position: absolute;
}

ol.processStateMovements ol > li { padding: 1em 0 0 1em; }

ol.processStateMovements > li > ol > li:not(:last-of-type):before {
    height: 3px;
    left: 20px;
    top: 3em;
    width: 3em;
}

ol.processStateMovements > li > ol > li:not(:last-of-type):after {
    height: 100%;
    left: 20px;
    top: 0;
    width: 3px;
}

ol.processStateMovements > li > ol > li:last-of-type:before {
    height: 3px;
    left: 20px;
    top: 3em;
    width: 3em;
}

ol.processStateMovements > li > ol > li:last-of-type:after {
    height: 3em;
    left: 20px;
    top: 0;
    width: 3px;
}`, "",{"version":3,"sources":["webpack://./ClientApp/styles/css/cardSourceMovement.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;;IAII,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;;;IAGI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA,+BAA+B,cAAc,EAAE;;AAE/C,gBAAgB,iBAAiB,EAAE;;AAEnC;IACI,YAAY;IACZ,cAAc;AAClB;;;AAGA;;;;;;IAMI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA,kCAAkC,oBAAoB,EAAE;;AAExD;IACI,WAAW;IACX,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,MAAM;IACN,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,MAAM;IACN,UAAU;AACd;;;AAGA;;;;IAII,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;;;IAGI,SAAS;IACT,UAAU;AACd;;AAEA;;;;IAII,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA,+BAA+B,cAAc,EAAE;;AAE/C;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;;;;;IAMI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA,mCAAmC,oBAAoB,EAAE;;AAEzD;IACI,WAAW;IACX,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,MAAM;IACN,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;IACV,MAAM;IACN,UAAU;AACd","sourcesContent":[".movementsContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: auto;\r\n    overflow: auto;\r\n}\r\n\r\nol.stageMovementsStages h4 {\r\n    text-align: center;\r\n    text-wrap: nowrap;\r\n    overflow: hidden;\r\n    max-width: 300px;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\nol.stageMovementsStages,\r\nol.stageMovementsStages ol,\r\nol.stageMovementsStages li,\r\nol.stageMovementsStages li > div {\r\n    position: relative;\r\n    margin-right: 6px;\r\n}\r\n\r\n.stageMovementsStages {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n    display: flex;\r\n}\r\n\r\n.arrowStage {\r\n    width: 300px;\r\n    height: 50px;\r\n    position: relative;\r\n    cursor: pointer;\r\n}\r\n\r\n.arrowStage:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 0;\r\n    bottom: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 12px solid white;\r\n    border-top: 25px solid transparent;\r\n    border-bottom: 25px solid transparent;\r\n}\r\n\r\n.arrowStage:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    right: -12px;\r\n    bottom: 0;\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 12px solid;\r\n    border-top: 25px solid transparent;\r\n    border-bottom: 25px solid transparent;\r\n}\r\n\r\n.arrowStageText {\r\n    position: absolute;\r\n    margin-top: 12px;\r\n    margin-left: 140px;\r\n    color: white;\r\n    font-family: SANS-SERIF;\r\n    font-size: 15px;\r\n    text-align: center;\r\n}\r\n\r\nol.stageMovementsStates,\r\nol.stageMovementsStates ol,\r\nol.stageMovementsStates li {\r\n    list-style: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nol.stageMovementsStates li > div {\r\n    width: 220px;\r\n    min-height: 80px;\r\n    margin-top: 30px;\r\n    margin-left: 50px;\r\n    padding: 10px;\r\n    background-color: #ececec;\r\n    border: 1px solid #d6d4d4;\r\n}\r\n\r\nol.stageMovementsStates span { display: block; }\r\n\r\n.boldSpanName { font-weight: bold; }\r\n\r\n.spanLength {\r\n    float: right;\r\n    color: #2a9c1a;\r\n}\r\n\r\n\r\nol.stageMovementsStages ol:before,\r\nol.stageMovementsStages ol:after,\r\nol.stageMovementsStages li:before,\r\nol.stageMovementsStages li:after,\r\nol.stageMovementsStages > li > div:before,\r\nol.stageMovementsStages > li > div:after {\r\n    background-color: #d6d4d4;\r\n    content: '';\r\n    position: absolute;\r\n}\r\n\r\nol.stageMovementsStages ol > li { padding: 1em 0 0 1em; }\r\n\r\nol.stageMovementsStages > li > ol > li:not(:last-of-type):before {\r\n    height: 3px;\r\n    left: 30px;\r\n    top: 6em;\r\n    width: 3em;\r\n}\r\n\r\nol.stageMovementsStages > li > ol > li:not(:last-of-type):after {\r\n    height: 100%;\r\n    left: 30px;\r\n    top: 0;\r\n    width: 3px;\r\n}\r\n\r\nol.stageMovementsStages > li > ol > li:last-of-type:before {\r\n    height: 3px;\r\n    left: 30px;\r\n    top: 6em;\r\n    width: 3em;\r\n}\r\n\r\nol.stageMovementsStages > li > ol > li:last-of-type:after {\r\n    height: 6em;\r\n    left: 30px;\r\n    top: 0;\r\n    width: 3px;\r\n}\r\n\r\n\r\nol.processMovements,\r\nol.processMovements ol,\r\nol.processMovements li,\r\nol.processMovements li > div {\r\n    position: relative;\r\n    margin-left: 6px;\r\n    list-style: none;\r\n}\r\n\r\n.processMovements {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nol.processItemMovements,\r\nol.processItemMovements ol,\r\nol.processItemMovements li {\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\nol.processItemMovements,\r\nol.processItemMovements ol,\r\nol.processItemMovements li,\r\nol.processMovements span {\r\n    display: block;\r\n}\r\n\r\nol.processItemMovements li > div {\r\n    width: 220px;\r\n    min-height: 70px;\r\n    margin-top: 15px;\r\n    margin-left: 45px;\r\n    padding: 10px;\r\n    background-color: #ececec;\r\n    border: 1px solid #d6d4d4;\r\n}\r\n\r\nol.processItemMovements span { display: block; }\r\n\r\n.processStateMovements {\r\n    display: flex;\r\n    left: 150px;\r\n    margin-top: -75px;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.processNameSpan {\r\n    margin-top: 35px;\r\n    margin-bottom: 5px;\r\n}\r\n\r\nol.processStateMovements h4 {\r\n    text-align: center;\r\n    text-wrap: nowrap;\r\n    overflow: hidden;\r\n    max-width: 300px;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\nol.processStateMovements ol:before,\r\nol.processStateMovements ol:after,\r\nol.processStateMovements li:before,\r\nol.processStateMovements li:after,\r\nol.processStateMovements > li > div:before,\r\nol.processStateMovements > li > div:after {\r\n    background-color: #d6d4d4;\r\n    content: '';\r\n    position: absolute;\r\n}\r\n\r\nol.processStateMovements ol > li { padding: 1em 0 0 1em; }\r\n\r\nol.processStateMovements > li > ol > li:not(:last-of-type):before {\r\n    height: 3px;\r\n    left: 20px;\r\n    top: 3em;\r\n    width: 3em;\r\n}\r\n\r\nol.processStateMovements > li > ol > li:not(:last-of-type):after {\r\n    height: 100%;\r\n    left: 20px;\r\n    top: 0;\r\n    width: 3px;\r\n}\r\n\r\nol.processStateMovements > li > ol > li:last-of-type:before {\r\n    height: 3px;\r\n    left: 20px;\r\n    top: 3em;\r\n    width: 3em;\r\n}\r\n\r\nol.processStateMovements > li > ol > li:last-of-type:after {\r\n    height: 3em;\r\n    left: 20px;\r\n    top: 0;\r\n    width: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
